<div class="home">
  <div class="row tiles">
    <div class="col-md-6">
      <div class="tile search">
        <div class="search-wrapper">
          <div class="ly-search input-group input-group-sm">
            <mat-form-field class="mat-form-field">
              <mat-label>Search Documentation </mat-label>
              <input matInput type="text" [(ngModel)]="searchValue" (keydown.enter)="search()" />
              <button matSuffix type="button" mat-icon-button (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <h3>Search Documentation</h3>
        <p>Quickly search Speedgoat software help content</p>
      </div>
    </div>

    <div class="col-md-6">
      <a class="tile" href="/help" target="_blank">
        <img src="/Portals/0/adam/SpeedgoatExtranet/zut9BsX2i0CiyckOWGwmIg/IconDocumntation/documentation.png" alt="Downloads" />
        <h3>Software Documentation</h3>
        <p>Access software documentation</p>
      </a>
    </div>

    <div class="col-md-6">
      <a class="tile" [routerLink]="['/', routesConst.downloads]">
        <img src="/Portals/0/adam/Content/-OeDcjQVvk-rx6Nw6sUVUQ/Image/downloads.png" alt="Downloads" />
        <h3>Downloads</h3>
        <p>Download software and hardware documentation</p>
      </a>
    </div>

    <div class="col-md-6">
      <a class="tile" [routerLink]="['/', routesConst.maintenance]">
        <img src="/Portals/0/adam/Content/1DhKGwBiuEq-L5dACDywbg/Image/maintenance.png" alt="Maintenance" />
        <h3>Maintenance</h3>
        <p>View and renew your maintenance</p>
      </a>
    </div>

    <div class="col-md-6">
      <a class="tile" [routerLink]="['/', routesConst.tutorials]">
        <img src="/Portals/0/adam/SpeedgoatExtranet/zut9BsX2i0CiyckOWGwmIg/IconTutorial/learning-tutorials.png" alt="Downloads" />
        <h3>How-to Tutorial Videos</h3>
        <p>Watch how-to videos for step-by-step guidance on operating your Speedgoat test system</p>
      </a>
    </div>

    <div class="col-md-6">
      <a class="tile" href="/reference-examples">
        <img src="/Portals/0/adam/SpeedgoatExtranet/zut9BsX2i0CiyckOWGwmIg/IconReferenceExamples/reference-examples.png" alt="Reference Examples" />
        <h3>Reference Examples</h3>
        <p>Explore fully-realized examples to get a head start with your application use cases</p>
      </a>
    </div>
  </div>
</div>
